import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {toSnakeCase} from 'utils/object';
import {request} from 'utils/request-axios';

export type ProfileNotificationFormFields = {
    nextPage: string;
    partnerMid: string;
};

export type ProfileNotificationSuccessResponse =
    Api.Response.Template.SuccessBasicMessage;

export type ProfileNotificationErrorResponse = Api.Response.Failure<
    keyof ProfileNotificationFormFields
>;

export const usePostProfileNotification = (): UseMutationResult<
    ProfileNotificationSuccessResponse,
    Error,
    ProfileNotificationFormFields
> => {
    const locale = useLocale();

    return useMutation((formData) =>
        request({
            formData: toSnakeCase(formData),
            locale,
            method: 'POST',
            url: '/ui/profile/notification/session/',
        }),
    );
};
